import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import startCase from 'lodash/startCase'

import './style.css.scss'

const MostViewedTag = (props) => (
  <div className="most-viewed-tag">
    {startCase(props.getTranslation(TRANSLATION_VALUE_KEYS.mostViewed))}
  </div>
)

export default withTranslation(TRANSLATION_KEYS.mostViewedTag)(MostViewedTag)
